export default __webpack_public_path__ + "static/image5-3d1073535fd74e9d6330b1008297625f.png";